import { render, staticRenderFns } from "./CallNext.vue?vue&type=template&id=3550793e&"
import script from "./CallNext.vue?vue&type=script&lang=js&"
export * from "./CallNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports